import { createReducer, on } from '@ngrx/store';
import { FinanceThreshold } from '../../models/finance-threshold.model';
import * as FinanceThresholdActions from './finance-thresholds.actions';

export interface FinanceThresholdState {
  thresholds: FinanceThreshold[];
  loading: boolean;
  error: any;
}

export const initialFinanceThresholdState: FinanceThresholdState = {
  thresholds: [],
  loading: false,
  error: null,
};

const sortThresholdsByValue = (thresholds: FinanceThreshold[]): FinanceThreshold[] => {
  return [...thresholds].sort((a, b) => a.value - b.value);
};

export const financeThresholdReducer = createReducer(
  initialFinanceThresholdState,
  on(FinanceThresholdActions.loadFinanceThresholds, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinanceThresholdActions.loadFinanceThresholdsSuccess, (state, { thresholds }) => ({
    ...state,
    thresholds: sortThresholdsByValue(thresholds),
    loading: false,
    error: null,
  })),
  on(FinanceThresholdActions.loadFinanceThresholdsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(FinanceThresholdActions.addFinanceThreshold, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinanceThresholdActions.addFinanceThresholdSuccess, (state, { threshold }) => ({
    ...state,
    thresholds: sortThresholdsByValue([...state.thresholds, threshold]),
    loading: false,
    error: null,
  })),
  on(FinanceThresholdActions.addFinanceThresholdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(FinanceThresholdActions.updateFinanceThreshold, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinanceThresholdActions.updateFinanceThresholdSuccess, (state, { threshold }) => ({
    ...state,
    thresholds: sortThresholdsByValue(state.thresholds.map((t) => (t.id === threshold.id ? threshold : t))),
    loading: false,
    error: null,
  })),
  on(FinanceThresholdActions.updateFinanceThresholdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(FinanceThresholdActions.deleteFinanceThreshold, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinanceThresholdActions.deleteFinanceThresholdSuccess, (state, { id }) => ({
    ...state,
    thresholds: sortThresholdsByValue(state.thresholds.filter((t) => t.id !== id)),
    loading: false,
    error: null,
  })),
  on(FinanceThresholdActions.deleteFinanceThresholdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
